import { render, staticRenderFns } from "./ClientConfig.vue?vue&type=template&id=486a7077&"
import script from "./ClientConfig.vue?vue&type=script&lang=js&"
export * from "./ClientConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports